import { LIBRARY_LAYOUT_SIZES } from '@mightyhive/theme';

/** Library list + detail layout dimensions (Figma Homepage + Library). */
export const LIBRARY_PAGE_LAYOUT_SIZES = {
  sectionTitleGap: 8,
  sectionToFiltersGap: 32,
  filterBarGap: 8,
  filterBarToToolbarGap: 24,
  toolbarGap: 12,
  cardGridGap: 24,
  cardRadius: 16,
  cardPadding: 32,
  cardMinHeight: 410,
  platformIconSize: 56,
  platformIconInnerSize: 20,
  platformIconRadius: 16,
  ownerAvatarSize: 28,
  tagChipHeight: LIBRARY_LAYOUT_SIZES.chipHeight,
  tagChipRadius: LIBRARY_LAYOUT_SIZES.chipBorderRadius,
  filterPillHeight: LIBRARY_LAYOUT_SIZES.pillHeight,
  filterPillRadius: LIBRARY_LAYOUT_SIZES.pillBorderRadius,
  toolbarControlHeight: 40,
  toolbarFieldRadius: 10,
} as const;

/** Staggered entrance delays for the Library page (milliseconds). */
export const LIBRARY_ENTRANCE_DELAYS = {
  heading: 0,
  heroSubtitle: 140,
  sectionTitle: 280,
  statusFilters: 400,
  toolbar: 520,
  cardBase: 140,
  cardStagger: 80,
} as const;
